import React, {useEffect, useState} from 'react';
import sections from './content';

// 吸顶导航栏的高度加一点余量：分区顶部滚到这条线以上，就算"当前所在分区"
const ACTIVE_OFFSET = 140;

function SubNav() {
    const [activeId, setActiveId] = useState(sections[0].id);

    useEffect(() => {
        const updateActive = () => {
            const atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
            let current = sections[0].id;
            for (const section of sections) {
                const el = document.getElementById(section.id);
                if (el && el.getBoundingClientRect().top <= ACTIVE_OFFSET) {
                    current = section.id;
                }
            }
            // 页面滚到底时，最后一个分区可能顶不到那条线，直接算最后一个
            setActiveId(atBottom ? sections[sections.length - 1].id : current);
        };
        updateActive();
        window.addEventListener('scroll', updateActive, {passive: true});
        return () => window.removeEventListener('scroll', updateActive);
    }, []);

    return (
        <nav className="info-subnav">
            <div className="container-fluid">
                {sections.map((section) => (
                    <a
                        key={section.id}
                        href={`#${section.id}`}
                        className={section.id === activeId ? 'active' : ''}
                        onClick={() => setActiveId(section.id)}
                    >
                        {/* tabLabel 可以是数组：每一项单独占一行，用来手动控制长标题的折行位置 */}
                        {[].concat(section.tabLabel).map((part, index) => (
                            <React.Fragment key={part}>
                                {index > 0 && <br/>}
                                {part}
                            </React.Fragment>
                        ))}
                    </a>
                ))}
            </div>
        </nav>
    );
}

export default SubNav;
